<div class="aca-dashboard">
  <!-- Hero / welcome -->
  <section class="aca-dashboard__hero">
    <div class="aca-dashboard__hero-text">
      <h1 class="aca-dashboard__title">
        {{ 'DMS.DASHBOARD.134E57' | translate }}<ng-container *ngIf="displayName()">, {{ displayName() }}</ng-container>
      </h1>
      <p class="aca-dashboard__subtitle">{{ 'DMS.DASHBOARD.31F6D6' | translate }}</p>
      <a class="aca-dashboard__cta" [routerLink]="heroAction.route">{{ heroAction.label | translate }}</a>
    </div>

    <!-- documents, a folder and a chart, in the panel's own light: the reference
         artwork's motif drawn rather than shipped as a raster, so it stays sharp
         at any width and carries no colour of its own to keep in step -->
    <div class="aca-dashboard__hero-art" aria-hidden="true">
      <svg viewBox="0 0 420 200" role="presentation" focusable="false">
        <g fill="#fff">
          <ellipse cx="96" cy="62" rx="52" ry="26" opacity="0.14" />
          <ellipse cx="66" cy="70" rx="34" ry="18" opacity="0.14" />
          <rect x="168" y="18" width="74" height="94" rx="8" opacity="0.9" />
          <rect x="182" y="36" width="46" height="6" rx="3" opacity="0.25" fill="#1d4ed8" />
          <rect x="182" y="50" width="46" height="6" rx="3" opacity="0.18" fill="#1d4ed8" />
          <rect x="182" y="64" width="30" height="6" rx="3" opacity="0.18" fill="#1d4ed8" />
          <path d="M250 44h56a10 10 0 0 1 10 10v76a10 10 0 0 1-10 10h-56z" opacity="0.5" />
          <path d="M108 96h44l10 12h74a10 10 0 0 1 10 10v52a10 10 0 0 1-10 10H108a10 10 0 0 1-10-10v-64a10 10 0 0 1 10-10z" opacity="0.82" />
          <rect x="330" y="120" width="16" height="60" rx="5" opacity="0.35" />
          <rect x="354" y="98" width="16" height="82" rx="5" opacity="0.5" />
          <rect x="378" y="132" width="16" height="48" rx="5" opacity="0.28" />
        </g>
      </svg>
    </div>
  </section>

  <!-- Stats -->
  <section class="aca-dashboard__stats">
    <div class="aca-card aca-stat">
      <div class="aca-stat__icon aca-stat__icon--blue"><mat-icon>description</mat-icon></div>
      <div class="aca-stat__body">
        <span class="aca-stat__value" *ngIf="!loading(); else statSkel">{{ stats().files }}</span>
        <span class="aca-stat__label">{{ 'DMS.DASHBOARD.0EC395' | translate }}</span>
      </div>
      <mat-icon class="aca-stat__ghost" aria-hidden="true">description</mat-icon>
    </div>
    <div class="aca-card aca-stat">
      <div class="aca-stat__icon aca-stat__icon--amber"><mat-icon>folder</mat-icon></div>
      <div class="aca-stat__body">
        <span class="aca-stat__value" *ngIf="!loading(); else statSkel">{{ stats().folders }}</span>
        <span class="aca-stat__label">{{ 'DMS.DASHBOARD.4A0C80' | translate }}</span>
      </div>
      <mat-icon class="aca-stat__ghost" aria-hidden="true">folder</mat-icon>
    </div>
    <div class="aca-card aca-stat">
      <div class="aca-stat__icon aca-stat__icon--green"><mat-icon>inventory_2</mat-icon></div>
      <div class="aca-stat__body">
        <span class="aca-stat__value" *ngIf="!loading(); else statSkel">{{ stats().total }}</span>
        <span class="aca-stat__label">{{ 'DMS.DASHBOARD.5F2E3C' | translate }}</span>
      </div>
      <mat-icon class="aca-stat__ghost" aria-hidden="true">donut_large</mat-icon>
    </div>
    <ng-template #statSkel><span class="aca-skeleton aca-stat__value-skel"></span></ng-template>
  </section>

  <!-- Quick actions -->
  <section class="aca-dashboard__section">
    <h2 class="aca-dashboard__section-title">{{ 'DMS.DASHBOARD.QUICK_ACTIONS' | translate }}</h2>
    <div class="aca-dashboard__actions">
      <a *ngFor="let action of visibleActions()" class="aca-card aca-action-tile" [routerLink]="action.route">
        <mat-icon>{{ action.icon }}</mat-icon>
        <span>{{ action.label | translate }}</span>
      </a>
    </div>
  </section>

  <!-- My Work — only when the user actually has tasks waiting -->
  <section class="aca-dashboard__section" *ngIf="myWork().length">
    <div class="aca-card aca-recent aca-mywork">
      <div class="aca-recent__head">
        <h2 class="aca-recent__title">
          <mat-icon class="aca-mywork__icon">inbox</mat-icon>
          {{ 'DMS.DASHBOARD.MY_WORK' | translate }}
          <span class="aca-mywork__count">{{ myWorkTotal() }}</span>
        </h2>
        <a class="aca-dashboard__see-all" routerLink="/my-work">{{ 'DMS.DASHBOARD.2705B6' | translate }}</a>
      </div>

      <button class="aca-recent__row aca-recent__row--clickable" *ngFor="let t of myWork()" (click)="openTask(t)">
        <mat-icon class="aca-recent__row-icon">assignment</mat-icon>
        <span class="aca-recent__row-name">{{ t.docName || t.name }}</span>
        <span class="aca-recent__row-type">{{ t.step | translate }}</span>
        <span class="aca-recent__row-date">{{ (t.dueAt | acaDate: 'd MMM y') || '' }}</span>
        <mat-icon class="aca-recent__row-go">chevron_right</mat-icon>
      </button>
    </div>
  </section>

  <!-- Expiry — only when something the reader can see is due or past it -->
  <section class="aca-dashboard__section" *ngIf="expiring().length">
    <div class="aca-card aca-recent aca-expiry">
      <div class="aca-recent__head">
        <h2 class="aca-recent__title">
          <mat-icon class="aca-expiry__icon">event_busy</mat-icon>
          {{ 'DMS.DASHBOARD.EXPIRY_TITLE' | translate }}
          <span class="aca-expiry__badge aca-expiry__badge--expired" *ngIf="expired()">
            {{ 'DMS.DASHBOARD.EXPIRY_EXPIRED' | translate: { p0: expired() } }}
          </span>
          <span class="aca-expiry__badge aca-expiry__badge--soon" *ngIf="expiringSoon()">
            {{ 'DMS.DASHBOARD.EXPIRY_SOON' | translate: { p0: expiringSoon() } }}
          </span>
        </h2>
        <a class="aca-dashboard__see-all" routerLink="/document-expiry" *ngIf="isAdmin()">
          {{ 'DMS.DASHBOARD.2705B6' | translate }}
        </a>
      </div>

      <button class="aca-recent__row aca-recent__row--clickable" *ngFor="let doc of expiring()" (click)="openDoc(doc)">
        <mat-icon class="aca-recent__row-icon" [class.aca-expiry__icon--expired]="doc.status === 'expired'">schedule</mat-icon>
        <span class="aca-recent__row-name">{{ doc.name }}</span>
        <span
          class="aca-expiry__status"
          [class.aca-expiry__status--expired]="doc.status === 'expired'"
          [class.aca-expiry__status--soon]="doc.status === 'soon'"
        >
          {{ (doc.status === 'expired' ? 'DMS.DASHBOARD.EXPIRY_L_EXPIRED' : 'DMS.DASHBOARD.EXPIRY_L_SOON') | translate }}
        </span>
        <span class="aca-recent__row-date">{{ doc.expiry | acaDate: 'd MMM y' }}</span>
        <mat-icon class="aca-recent__row-go">chevron_right</mat-icon>
      </button>
    </div>
  </section>

  <!-- Recent -->
  <section class="aca-dashboard__section">
    <div class="aca-card aca-recent">
      <div class="aca-recent__head">
        <h2 class="aca-recent__title">{{ 'DMS.DASHBOARD.744EBE' | translate }}</h2>
        <a class="aca-dashboard__see-all" routerLink="/recent-files">{{ 'DMS.DASHBOARD.2705B6' | translate }}</a>
      </div>

      <div class="aca-recent__cols" aria-hidden="true">
        <span></span>
        <span>{{ 'DMS.DASHBOARD.COL_NAME' | translate }}</span>
        <span>{{ 'DMS.DASHBOARD.COL_TYPE' | translate }}</span>
        <span>{{ 'DMS.DASHBOARD.COL_UPDATED' | translate }}</span>
        <span></span>
      </div>

      <!-- skeleton -->
      <ng-container *ngIf="loading()">
        <div class="aca-recent__row" *ngFor="let s of skeletons">
          <span class="aca-skeleton aca-recent__row-icon"></span>
          <span class="aca-skeleton aca-recent__row-line"></span>
        </div>
      </ng-container>

      <!-- data -->
      <ng-container *ngIf="!loading()">
        <button class="aca-recent__row aca-recent__row--clickable" *ngFor="let node of recent()" (click)="open(node)">
          <mat-icon class="aca-recent__row-icon" [class.is-folder]="node.entry.isFolder">{{ iconFor(node) }}</mat-icon>
          <span class="aca-recent__row-name">{{ node.entry.name }}</span>
          <span class="aca-recent__row-type">{{ typeLabelFor(node) | translate }}</span>
          <span class="aca-recent__row-date">{{ node.entry.modifiedAt | acaDate: 'd MMM y' }}</span>
          <mat-icon class="aca-recent__row-go">chevron_right</mat-icon>
        </button>

        <aca-page-state
          *ngIf="recent().length === 0"
          state="empty"
          [title]="'DMS.DASHBOARD.267AFA' | translate"
          [message]="'DMS.DASHBOARD.EMPTY_MESSAGE' | translate"
          [actionLabel]="'DMS.DASHBOARD.EMPTY_ACTION' | translate"
          (action)="goToAllDocuments()"
        />
      </ng-container>
    </div>
  </section>
</div>
